import { render, staticRenderFns } from "./v-card4.vue?vue&type=template&id=c40485e6&scoped=true"
import script from "./v-card4.vue?vue&type=script&lang=js"
export * from "./v-card4.vue?vue&type=script&lang=js"
import style0 from "./v-card4.vue?vue&type=style&index=0&id=c40485e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40485e6",
  null
  
)

export default component.exports